import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    RadialLinearScale,
    PolarAreaController
} from 'chart.js';

import { PolarArea } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    RadialLinearScale,
    PolarAreaController
);

export default function PolarAreaChart(props) {
    const chartOptions = {
        ...props.options,
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <div style={{
            minWidth: "30%",
            marginTop: '10px',
            height: "85%"
        }}>
            <PolarArea data={props.data} options={chartOptions} />
        </div>
    );
}
